import React from 'react'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { Loading, WithoutResultsPanel } from '../../components/UI'

/*

Copyright 2022-04-28 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se modifica componente norows por withoutresultspanel 
*/

interface tabContent {
  id: number | undefined
  content: string | JSX.Element | JSX.Element[]
}

interface tabEntity {
  id: number | undefined
  entity: string | JSX.Element | JSX.Element[]
}

const a11yProps = (index: any) => {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`
  }
}

interface ScrollableTabsProps {
  content?: tabContent[]
  entity: tabEntity[]
  isLoading: boolean
  child: JSX.Element | JSX.Element[]
  onClick: (id: number) => void
  rowsLength: number
}

export const ScrollableTabs: React.FC<ScrollableTabsProps> = ({
  entity,
  isLoading,
  child,
  onClick,
  rowsLength
}) => {
  const [value, setValue] = React.useState<number>(0)
  const tabSx = (theme: any) => ({
    borderTopRightRadius: 6,
    borderTopLeftRadius: 6,
    backgroundColor: '#CBCBCB',
    margin: 2,
    color: 'black',
    '&:hover': {
      color: '#004BB1',
      opacity: 1
    },
    '&.Mui-selected': {
      color: '#004BB1',
      fontWeight: theme.typography.fontWeightMedium
    },
    '&:focus': {
      color: '#004BB1'
    }
  })

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue)
  }

  return (
    <div style={{ flexGrow: 1, width: '100%' }}>
      <AppBar position='static' color='default'>
        {entity.length > 0 && (
          <Tabs
            value={value}
            onChange={handleChange}
            variant='scrollable'
            scrollButtons='auto'
            TabIndicatorProps={{
              sx: { backgroundColor: '#004BB1' }
            }}
          >
            {entity!.map((ent, index) => (
              <Tab
                sx={tabSx}
                label={ent.entity}
                {...a11yProps(index)}
                onClick={() => onClick(ent.id!)}
              />
            ))}
          </Tabs>
        )}
      </AppBar>

      {!isLoading && rowsLength > 0 ? (
        child
      ) : !isLoading && rowsLength === 0 ? (
        <WithoutResultsPanel />
      ) : (
        <Loading />
      )}
    </div>
  )
}
